import { StyleSheet } from 'aphrodite';
import { darkGrayFontColor, grayIconFill, white } from '../../styles/colors';
import { BreakPoints, BrowserMediaQueries, CssSelectors } from '../../styles/styles';

const actionButtonStyles = CssSelectors.allChildren(
	{
		height: 20,
		width: 20,
	},
	'svg'
);

export const styleSheet = StyleSheet.create({
	fullWidth: {
		width: '100%',
	},
	anchor: {
		[BrowserMediaQueries.IE11]: {
			transform: 'translate3d(-1px,2px,0)',
		},
	},
	button: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'transparent',
		border: 'none',
		borderRadius: 3,
		padding: '4px 8px',
		marginRight: 8,
		cursor: 'pointer',
		':hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	actionButton: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		padding: '4px 12px',
		marginRight: 8,
		borderRadius: 3,
		cursor: 'pointer',
		backgroundColor: 'transparent',
		transition: 'background-color 0.2s',
		whiteSpace: 'nowrap',
		border: 'none',
		boxSizing: 'border-box',
		height: 32,
		':hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	actionButtonEnabled: {
		opacity: 1,
		alignItems: 'center',
		background: 'none',
		borderRadius: 20,
		boxShadow: 'none',
		display: 'flex',
		marginRight: 12,
		padding: '8px 10px',
		transform: 'translate3d(0,0,0)',
		transition: 'background 0.2s, box-shadow 0.2s, transform 0.1s',
		':active': {
			boxShadow: `0 0 2px 1px rgba(0,0,0, 0.1)`,
			transform: 'translate3d(0,0,0)',
		},
		':hover': {
			background: 'white',
			transform: 'translate3d(0,-1px,0)',
			boxShadow: `0 1px 2px 1px rgba(0,0,0, 0.1)`,
		},
	},
	actionButtonIconOnly: {
		padding: '4px 8px',
	},
	buttonText: {
		marginLeft: 6,
		whiteSpace: 'nowrap',
		[BreakPoints.forMaxWidth(1080)]: {
			display: 'none',
		},
	},
	container: {
		alignItems: 'center',
		display: 'flex',
		height: 62,
		width: '100%',
		minWidth: 200,
	},
	actionButtonsContainer: {
		display: 'flex',
		alignItems: 'center',
		flexGrow: 1,
		flexShrink: 0,
		// This is a hack to fix the alignment of the first button so the shadow is not cut off
		height: 34,
		...CssSelectors.allChildren(
			{
				marginLeft: 2,
			},
			':first-child'
		),
	},
	defaultButtonStyles: {
		...actionButtonStyles,
	},
	export: {
		'--lev-people-action-bar-button-hover-shadow': 'rgba(137,201,71, 0.4)',
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(137,201,71, 0.4)`,
		},
	},
	noMargin: {
		margin: 0,
	},
	restoreContactText: {
		color: grayIconFill,
		textAlign: 'center',
	},
	sendCard: {
		'--lev-people-action-bar-button-hover-shadow': 'rgba(0, 170, 232, 0.4)',
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(0, 170, 232, 0.4)`,
		},
	},
	sendEmail: {
		...actionButtonStyles,
		'--lev-people-action-bar-button-hover-shadow': 'rgba(234,129,96, 0.4)',
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(234,129,96, 0.4)`,
		},
	},
	sendText: {
		'--lev-people-action-bar-button-hover-shadow': 'rgba(110, 39, 163, 0.4)',
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(110, 39, 163, 0.4)`,
		},
	},
	tag: {
		'--lev-people-action-bar-button-hover-shadow': 'rgba(4,108,182, 0.4)',
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(4,108,182, 0.4)`,
		},
	},
	delete: {
		'--lev-people-action-bar-button-hover-shadow': 'rgba(208, 2, 27, 0.4)',
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(208, 2, 27, 0.4)`,
		},
	},
	moreButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '0 10px',
		height: 32,
		cursor: 'pointer',
		borderRadius: 3,
		border: 'none',
		backgroundColor: 'transparent',
		':hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	moreMenuContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		width: '100%',
		gap: 8,
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'div'
		),
	},
	moreMenuButton: {
		width: '100%',
	},
	menuContainer: {
		minWidth: 150,
		backgroundColor: white,
		borderRadius: 3,
		boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
		overflow: 'hidden',
	},
	menuItem: {
		display: 'flex',
		alignItems: 'center',
		padding: '8px 12px',
		cursor: 'pointer',
		':hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	menuItemDisabled: {
		opacity: 0.5,
		cursor: 'not-allowed',
		':hover': {
			backgroundColor: 'transparent',
		},
	},
	menuItemIcon: {
		marginRight: 8,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 16,
		height: 16,
	},
	menuItemText: {
		fontSize: 13,
		color: grayIconFill,
	},
	keepInTouch: {
		...actionButtonStyles,
		opacity: 1,
		alignItems: 'center',
		background: 'none',
		borderRadius: 20,
		boxShadow: 'none',
		display: 'flex',
		marginRight: 12,
		padding: '8px 10px',
		transform: 'translate3d(0,0,0)',
		transition: 'background 0.2s, box-shadow 0.2s, transform 0.1s',
		':active:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(62,139,254, 0.4)`,
			transform: 'translate3d(0,0,0)',
		},
		':hover:not(:disabled)': {
			background: 'white',
			transform: 'translate3d(0,-1px,0)',
			boxShadow: `0 1px 2px 1px rgba(62,139,254, 0.4)`,
		},
	},
	keepInTouchMenu: {
		display: 'flex',
		flexDirection: 'column',
		minWidth: 150,
	},
	keepInTouchMenuItem: {
		padding: '8px 12px',
		cursor: 'pointer',
		fontSize: 13,
		color: darkGrayFontColor,
		':hover': {
			backgroundColor: '#f5f5f5',
		},
	},
});
